module.exports = __webpack_public_path__ + "img/About.8f6ff48c.svg";